<template>
  <div>
    <div>
      <div class="block select-none">
        <nav class="flex">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            :class="selectedTab === tab.primaryText ? 'text-gray-700 bg-gray-100 focus:text-gray-800 focus:bg-indigo-200' : 'text-gray-500 hover:text-gray-700 focus:text-gray-600 focus:bg-indigo-50'"
            class="px-3 py-2 font-medium text-sm leading-5 rounded-md
            cursor-pointer transition-all duration-500"
            @click="selectTab(tab)"
          >
            {{ tab.primaryText }}
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedTab: {
      type: String,
      default: '',
    },
  },

  data() {
    return {

    };
  },

  methods: {
    getClasses(tab, index) {
      let classes = '';

      if (index === 0) {
        classes += 'ml-4 ';
      } else {
        classes += 'ml-8 ';
      }

      if (tab === this.view) {
        classes += 'text-gray-800 hover:text-gray-700 border-gray-800';
      } else {
        classes += 'text-gray-500 hover:text-gray-700 hover:border-gray-300  focus:text-gray-700 focus:border-gray-300 ';
      }

      return classes;
    },

    getIconClasses(tab) {
      let classes = '';

      if (tab === this.view) {
        classes += 'text-gray-800 hover:text-gray-700 border-gray-800';
      } else {
        classes += 'text-gray-500 hover:text-gray-700 hover:border-gray-300  focus:text-gray-700 focus:border-gray-300 ';
      }

      return classes;
    },

    selectTab(tab) {
      this.$emit('select', tab);
    },
  },

};
</script>
